import { BaseContainerModel } from '../../base-container.model';
import { bl_cms_activity_highlight_RowClass } from '../../../dbschema';
import { bl_cms_activities_hdr_RowClass } from '../../../dbschema';

export class CmsActivityHighlightWithActivityContainerModel extends BaseContainerModel {
    bl_cms_activity_highlight: bl_cms_activity_highlight_RowClass = new bl_cms_activity_highlight_RowClass();
    bl_cms_activities_hdr: bl_cms_activities_hdr_RowClass = new bl_cms_activities_hdr_RowClass();
}
